import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';

const NotFound = () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Désolé, la page que vous cherchez n'existe pas."
      extra={
        <Link to="/">
          <Button type="primary">Retour à l'accueil</Button>
        </Link>
      }
    />
  );
};

export default NotFound; 